import { Variant } from 'components/Interview/List';
import Interview from 'types/Interview';

const isInterviewActionRequired = (
  variant: Variant,
  interview: Interview,
  currentUserId?: number, // <-- AJOUTER CECI
): boolean => {
  switch (interview.status) {
    case 'WAITING_MENTEE':
      // AJOUTER CETTE CONDITION :
      if (currentUserId && interview.authorId === currentUserId) {
        return false; 
      }
      if (variant === 'mentee') {
        return true;
      }
      return false;

    case 'ACCEPTED':
      
      if (
        (variant === 'mentor' || variant === 'mentee') &&
        interview.date &&
        new Date().getTime() - new Date(interview.date).getTime() >
          -1000 * 60 * 15
      ) {
        return true;
      }
      return false;

    case 'WAITING_REVIEW':
      if (variant === 'mentor' && !interview.mentorReview) {
        return true;
      }
      if (variant === 'mentee' && !interview.menteeReview) {
        return true;
      }
      return false;

    default:
      return false;
  }
};

export default isInterviewActionRequired;
